import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProgressLoaderComponent } from './progress-loader.component';

@NgModule({
  declarations: [
    ProgressLoaderComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule
  ],
  exports: [
    ProgressLoaderComponent
  ]
})
export class ProgressLoaderModule { }
